const IS_PROD = process.env.NODE_ENV === 'production';

const PROD_DOMAIN = 'epncrypto.com';
const YANDEX_METRIKA_SCRIPT_ID = 'crypto-yandex-metrika-script';

declare global {
    interface Window {
        ym?: (...args: unknown[]) => void;
        cryptoYmInitialized?: boolean;
    }
}

export const initCryptoMetric = (): void => {
    if (typeof window === 'undefined') return;
    if (window.cryptoYmInitialized) return;
    if (!IS_PROD || window.location.host !== PROD_DOMAIN) return;

    const ymStub =
        window.ym ||
        ((...args: unknown[]) => {
            ((ymStub as typeof ymStub & { a?: unknown[][] }).a =
                (ymStub as typeof ymStub & { a?: unknown[][] }).a || []).push(args);
        });

    (ymStub as typeof ymStub & { l?: number }).l = Date.now();
    window.ym = ymStub;

    if (!document.getElementById(YANDEX_METRIKA_SCRIPT_ID)) {
        const script = document.createElement('script');
        const [firstScript] = document.getElementsByTagName('script');

        script.async = true;
        script.src = 'https://mc.yandex.ru/metrika/tag.js';
        script.id = YANDEX_METRIKA_SCRIPT_ID;
        firstScript?.parentNode?.insertBefore(script, firstScript);
    }

    window.ym?.(89120816, 'init', {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
    });

    window.cryptoYmInitialized = true;
};

// Метрика для лендингов на https://epncrypto.com/ru
export const CryptoMetricHead: React.FC = () => {
    return (
        <>
            {/* Facebook Pixel */}
            <meta name="facebook-domain-verification" content="n7vtq0wxfchyzl36jyvny7d8kvik97" />
            {/* END Facebook pixel */}
        </>
    );
};

export const CryptoMetricBody: React.FC = () => null;
